module.exports = {
  buttons: {
    add: 'New',
    back: 'Back',
    cancel: 'Cancel',
    clear: 'Clear',
    fields: 'Fields',
    filter: 'Filter',
    ok: 'Ok',
    refresh: 'Refresh',
    reset: 'Reset',
    save: 'Save',
    remove: 'Remove'
  }
}



// WEBPACK FOOTER //
// ./~/rctui/lang/en/buttons.js